(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-row-banner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-row-banner.js');

'use strict';

const _excluded = ["productItsId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.lotto.components.play.views.AndraChansenRowBanner = Marionette.View.extend({
  ballRowOptions: {},
  ballRowSize: 200,
  modelEvents: {
    'change:hasJoker change:numberOfValidBoards change:drawCount change:rowPriceMulti change:selectedDays': 'update'
  },
  template(_ref) {
    let {
      banners
    } = _ref;
    return banners.render();
  },
  templateContext() {
    return {
      banners: this.banners
    };
  },
  initialize() {
    this.banners = svs.numbergames.andra_chansen.banners.rowBanner(this.getBannerData());
  },
  update() {
    this.banners.update(this.getBannerData());
  },
  getBannerData() {
    const draws = svs.numbergames.game.draw.drawNumbers(this.model.get('selectedDays'));
    return _objectSpread({
      size: this.getOption('ballRowSize'),
      lottoDraws: draws.map(_ref2 => {
        let {
            productItsId
          } = _ref2,
          rest = _objectWithoutProperties(_ref2, _excluded);
        return _objectSpread({
          productId: productItsId
        }, rest);
      }),
      wager: {
        rowCount: this.model.get('numberOfValidBoards'),
        numberOfDays: this.model.get('selectedDays').length,
        drawCount: this.model.get('drawCount'),
        hasJoker: this.model.get('hasJoker'),
        hasLotto2: this.model.get('rowPriceMulti') > 1,
        isSubscription: this.model.get('isSubscription')
      }
    }, this.getOption('ballRowOptions'));
  }
});

 })(window);